import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from '../models/snitem';

@RegisterItem()
export class SNAgendaAppointment extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNAgendaAppointment';
    }

    get patientInfo(): string {
        return (this.getProperty('PatientInfo') === null) ? '' : this.getProperty('PatientInfo');
    }

    public clone(): any {
        return new SNAgendaAppointment();
    }
}
